// Generated by scripts/generate-brand-assets.mjs.
export const BRAND_MARK_PATH =
  "M40 8H60C77.673 8 92 22.327 92 40V48C92 59.4 85.64 70.04 75 75V42C75 32.059 66.941 24 57 24H43C33.059 24 25 32.059 25 42V44C25 53.941 33.059 62 43 62H55C58.1 62 60.1 63.1 62.5 65.3L73 75C74.3 76.2 75 77.7 75 79.5V85C75 89.3 70.5 91.4 67.2 89L53 79H40C22.327 79 8 64.673 8 47V40C8 22.327 22.327 8 40 8Z";
export const BRAND_GRADIENT_TOP = "#3a7cfd";
export const BRAND_GRADIENT_BOTTOM = "#165ce3";
